import { Action } from '@ngrx/store';
import {
  ReportsOptions, ReportsDownloadRequestPayload, ReportsAvailabilityRequest,
  ReportsAvailability, ReportsExcelDownloadRequestPayload
} from './reports.models';
import { DatesIntervalRequest, DatesInterval } from '../../global/interfaces';

export enum ActionTypes {
  LOAD_REPORTS_DATES = '[Reports] Load Reports Dates Action',
  LOAD_REPORTS_DATES_SUCCESS = '[Reports] Load Reports Dates Success Action',
  LOAD_REPORTS_DATES_FAILED = '[Reports] Load Reports Dates Failed Action',

  LOAD_REPORTS_AVAILABILITY = '[Reports] Load Reports Availability Action',
  LOAD_REPORTS_AVAILABILITY_SUCCESS = '[Reports] Load Reports Availability Success Action',
  LOAD_REPORTS_AVAILABILITY_FAILED = '[Reports] Load Reports Availability Failed Action',

  SET_CHECKBOX_OPTIONS = '[Reports] Set Checkbox Options Action',

  SET_YEAR_FILTER = '[Reports] Set Year Filter Action',
  SET_MONTH_FILTER = '[Reports] Set Month Filter Action',

  SET_REPORTS_VISIT = '[Reports] Set Reports Visited Action',

  REPORTS_DOWNLOAD = '[Reports] Download Reports PDF Action',
  REPORTS_EXCEL_DOWNLOAD = '[Reports] Download Excel Reports PDF Action',

  RESET_REPORTS_DATA = '[Reports] Reset Reports Data Action'
}

export class LoadReportsDatesAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES;

  public constructor(public payload: DatesIntervalRequest) {
  }
}

export class LoadReportsDatesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES_SUCCESS;

  public constructor(public payload: DatesInterval) {
  }
}

export class LoadReportsDatesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_DATES_FAILED;

  public constructor(public payload: any) {
  }
}

export class LoadReportsAvailabilityAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_AVAILABILITY;

  public constructor(public payload: ReportsAvailabilityRequest) {
  }
}

export class LoadReportsAvailabilitySuccessAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_AVAILABILITY_SUCCESS;

  public constructor(public payload: ReportsAvailability[]) {
  }
}

export class LoadReportsAvailabilityFailedAction implements Action {
  readonly type = ActionTypes.LOAD_REPORTS_AVAILABILITY_FAILED;

  public constructor(public payload: any) {
  }
}

export class SetReportsCheckboxOptionsAction implements Action {
  readonly type = ActionTypes.SET_CHECKBOX_OPTIONS;

  public constructor(public payload: ReportsOptions) {
  }
}

export class SetReportsYearFilterAction implements Action {
  readonly type = ActionTypes.SET_YEAR_FILTER;

  public constructor(public payload: number) {
  }
}

export class SetReportsMonthFilterAction implements Action {
  readonly type = ActionTypes.SET_MONTH_FILTER;

  public constructor(public payload: number) {
  }
}

export class ReportsDownloadAction implements Action {
  readonly type = ActionTypes.REPORTS_DOWNLOAD;

  public constructor(public payload: ReportsDownloadRequestPayload) {
  }
}

export class ReportsExcelDownloadAction implements Action {
  readonly type = ActionTypes.REPORTS_EXCEL_DOWNLOAD;
  public constructor(public payload: ReportsExcelDownloadRequestPayload) {
  }
}

export class SetReportsVisitAction implements Action {
  readonly type = ActionTypes.SET_REPORTS_VISIT;
}

export class ResetReportsDataAction implements Action {
  readonly type = ActionTypes.RESET_REPORTS_DATA;
}

export type Actions =
  LoadReportsDatesAction |
  LoadReportsDatesSuccessAction |
  LoadReportsDatesFailedAction |
  LoadReportsAvailabilityAction |
  LoadReportsAvailabilitySuccessAction |
  LoadReportsAvailabilityFailedAction |
  SetReportsCheckboxOptionsAction |
  SetReportsYearFilterAction |
  SetReportsMonthFilterAction |
  ReportsDownloadAction |
  SetReportsVisitAction |
  ResetReportsDataAction |
  ReportsExcelDownloadAction;
